import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "zh", "zh-TW"],
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

console.log("Current language:", i18next.language);
if (!i18next.language || i18next.language === "zh") {
  i18next.changeLanguage("zh-TW");
  console.log("Language set to zh-TW");
}

export default i18next;
